import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import axios from 'axios';
import { storage } from '@vmos2/core';

const usePredefinedVersion = localStorage.getItem('vm/__usePredefinedVersions');

export const PredefinedVersions = () => {
	const [deployedApps, setDeployedApps] = useState([]);
	const [currentVersion, setCurrenVersion] = useState('');
	useEffect(() => {
		if (usePredefinedVersion) {
			axios.get('/versions.json').then(({ data }) => setDeployedApps(data));
			storage.getItem('__appVersion').then(v => setCurrenVersion(v || ''));
		}
	}, []);
	const onChangeVersion = async v => {
		if (v) {
			await storage.setItem('__appVersion', v);
		} else {
			await storage.removeItem('__appVersion');
		}
		window.location.reload();
	};
	if (!usePredefinedVersion) return null;
	return (
		<Apps>
			<select value={currentVersion} onChange={e => onChangeVersion(e.target.value)}>
				<option value="">version</option>
				{deployedApps.map(({ origin, version }) => (
					<option key={version} value={version}>{version} ({ origin })</option>
				))}
			</select>
		</Apps>
	);
};

const Apps = styled('div')`
	position: fixed;
	bottom: 0;
	left: 0;
	opacity: 0.2;
`;
